import { createFileRoute } from "@tanstack/react-router";
import InvoicesConfigurations from "@/components/invoices/configuration/invoices-configuration";
import InvoicesConfigurationNavigation from "@/components/invoices/configuration/invoices-configuration-navigation";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/invoices/",
)({
  component: InvoicesSettingsPage,
});

function InvoicesSettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "invoices_configurations", actions: ["read", "update"] },
      ]}
    >
      <div className="gap-2 flex-col flex">
        <InvoicesConfigurationNavigation />
        <InvoicesConfigurations module="invoices_configurations" />
      </div>
    </RouteGuardPermissions>
  );
}
